module.exports = __webpack_public_path__ + "static/media/rc-admin-icon.5817b1f2.svg";